export function isAuthenticatedUsecaseFactory(deps) {
    return deps.authRepository.isAuthenticated;
}
//# sourceMappingURL=is-authenticated.usecase.js.map